angular.module('shared').factory('ToggleTableFiltersService', ["CwStorage", function(CwStorage) {
  return {
    getStorageKey: function(key) {
      return `${key}FiltersOpen`;
    },
    isOpen: function(key) {
      var storageKey;
      storageKey = this.getStorageKey(key);
      return JSON.parse(CwStorage.getItem(storageKey));
    },
    toggle: function(val, key) {
      var storageKey;
      storageKey = this.getStorageKey(key);
      if (val) {
        return CwStorage.setItem(storageKey, val);
      } else {
        return CwStorage.removeItem(storageKey);
      }
    }
  };
}]);
